import React from "react";
import About from "../components/About/About";
import CtaOne from "../components/CtaOne";
import GetStarted from "../components/GetStarted";
import HeroOne from "../components/Hero/HeroOne";
import HeroSocials from "../components/Hero/HeroSocials";
import LatestReport from "../components/Reports/LatestReport";
import Reports from "../components/Reports/Reports";
import ServicesOne from "../components/Services/ServicesOne";
import 'aos/dist/aos.css'
import { useFetchLinksQuery } from "../app/feature/API/Helpers";
const HomeOne = () => {

const {data:HeaderLink} = useFetchLinksQuery()
const isShowReport = HeaderLink?.some(
  (e) => e?.title === "Industry Reports" && e?.show_link !== 0
);

  return (
    <>
      <HeroSocials />
      <HeroOne />
      <About />
      <GetStarted/>
      <ServicesOne />
      <CtaOne />
      <Reports />
      {isShowReport&&<LatestReport/>}
    </>
  );
};

export default React.memo(HomeOne);
